<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-8 mx-auto">
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.expenses.companyExpenseType")}} <span class="red">*</span></label>
                                    <v-select v-model="companyExpenses.companyExpenseTypeDto" label="displayName"
                                              :options="companyExpensesTypes"
                                              :filterable="false"
                                              :class="{invalid : $v.companyExpenses.companyExpenseTypeDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.displayName"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.companyExpenses.companyExpenseTypeDto.$error">
                                        {{$t("reportGeneralDirector.category.expenses.companyExpenseType")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.expenses.name")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="companyExpenses.name"
                                           :class="{invalid : $v.companyExpenses.name.$error}"/>
                                    <div class="red" v-if="$v.companyExpenses.name.$error">
                                        {{$t("reportGeneralDirector.category.expenses.name")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.expenses.paidDate")}}</label>
                                    <custom-date-picker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="companyExpenses.paidDate"
                                            :date="companyExpenses.paidDate"
                                            :clear-button="true">
                                    </custom-date-picker>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.expenses.paymentNumber")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="companyExpenses.paymentNumber"
                                           :class="{invalid : $v.companyExpenses.paymentNumber.$error}"/>
                                    <div class="red" v-if="$v.companyExpenses.paymentNumber.$error">
                                        {{$t("reportGeneralDirector.category.expenses.paymentNumber")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.expenses.paymentAmount")}} <span
                                            class="red">*</span></label>
                                    <numeric-input v-model="companyExpenses.paymentAmount" :precision="2" required></numeric-input>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.expenses.description")}}</label>
                                    <textarea type="text" class="form-control" v-model="companyExpenses.description"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing">
                                    {{$t("action.save")}}
                                </button>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    // import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    import {required/*, requiredUnless, minLength*/} from 'vuelidate/lib/validators';
    import CustomDatePicker from '@/views/common/CustomDatePicker';
    import {formatDate} from '@/shared/utils';

    export default {
        name: "CompanyExpensesAddEditView",
        components: {
            CustomDatePicker
        },
        data() {
            return {
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                show: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                employeeFilter: initFilterModel(),
                companyExpenses: {
                    id: null,
                    name: null,
                    paidDate: formatDate(new Date()),
                    companyExpenseTypeDto: null,
                    paymentNumber: null,
                    paymentAmount: null,
                    description: null
                },
                companyExpensesTypes: [],
            }
        },
        validations() {
            return {
                companyExpenses: {
                    paymentAmount: {
                        required: required
                    },
                    paymentNumber: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    companyExpenseTypeDto: {
                        required: required
                    },
                },
            };
        },
        computed: {

        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                this.$http.get('/company-expense-type')
                    .then(res => {
                        vm.companyExpensesTypes = res.data;
                    }, (err) => {
                        console.log(err);
                        vm.loading = false;
                    });

                if (id) {
                    this.$http.get('/company-expenses/view/' + id)
                        .then(res => {
                            vm.companyExpenses = res.data;
                        }, (err) => {
                            console.log(err);
                            vm.loading = false;
                        });
                }
            },
            cancel() {
                this.$router.push('/report-general-director/company-expenses');
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                // if (this.mibLetterDate) {
                //     this.asset.mibLetterDate = formatDate(this.mibLetterDate);
                // }
                this.companyExpenses.companyExpenseType = this.companyExpenses.companyExpenseTypeDto.code;
                this.companyExpenses.companyExpenseTypeDto = null;

                this.$http.post('company-expenses/save', this.companyExpenses)
                    .then(res => {

                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/report-general-director/company-expenses');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>

</style>
